"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExtractedValues = void 0;
var utils_1 = require("../../../../utils");
var bit_matrix_1 = require("../../../types/record/bit-matrix");
var useExtractedValues = function (croppedRectAspectRatio$, positivePointsRelative$, negativePointsRelative$, cursorTypeOnCanvas$, croppedRectPixel$, readonlyArea$, plotMode$) {
    var croppedRectAspectRatio = (0, utils_1.useStreamValue)(croppedRectAspectRatio$, 1);
    var positivePointsRelative = (0, utils_1.useStreamValue)(positivePointsRelative$, (0, utils_1.IList)());
    var negativePointsRelative = (0, utils_1.useStreamValue)(negativePointsRelative$, (0, utils_1.IList)());
    var cursorTypeOnCanvas = (0, utils_1.useStreamValue)(cursorTypeOnCanvas$, 'default');
    var croppedRectPixelSize = (0, utils_1.useStreamValue)(croppedRectPixel$, (0, utils_1.IRect)());
    var readonlyArea = (0, utils_1.useStreamValue)(readonlyArea$, (0, bit_matrix_1.IBitMatrix)());
    var plotMode = (0, utils_1.useStreamValue)(plotMode$, '+');
    return {
        croppedRectAspectRatio: croppedRectAspectRatio,
        positivePointsRelative: positivePointsRelative,
        negativePointsRelative: negativePointsRelative,
        cursorTypeOnCanvas: cursorTypeOnCanvas,
        croppedRectPixelSize: croppedRectPixelSize,
        readonlyArea: readonlyArea,
        plotMode: plotMode
    };
};
exports.useExtractedValues = useExtractedValues;
